import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
    AM_DataDownload,
    DataDownload,
    InfoDownload,
} from "src/app/models/am-data-download";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class DownloadService {
    constructor(private http: HttpClient) {}

    getAll(): Observable<DataDownload[]> {
        return this.http.get<DataDownload[]>(
            environment.localUrl + "Download/DataDownload/",
            {
                withCredentials: true,
            }
        );
    }

    getAllInfo(): Observable<InfoDownload[]> {
        return this.http.get<InfoDownload[]>(
            environment.localUrl + "Download/InfoDownload/",
            {
                withCredentials: true,
            }
        );
    }

    getAllTech(): Observable<InfoDownload[]> {
        return this.http.get<InfoDownload[]>(
            environment.localUrl + "Download/TechDownload/",
            {
                withCredentials: true,
            }
        );
    }
}
